<template>
  <div class="wrapper">
    <ul class="current_user">
      <li>姓名：{{ selectdata.patientname }}</li>
      <li>就诊ID号：<span>{{ selectdata.patientId }}</span></li>
      <!-- <li>身份证：<span>{{ selectdata.idcardno.replace(/(\w{4})\w*(\w{4})/, "$1******$2") }}</span></li> -->
      <span @click="showNation = true" class="switch">切换就诊人</span>
      <img src="@/assets/record/jkm2.png" @click.stop="cardbtn(selectdata)"/>
    </ul>
    <div v-if="wjsShow">
      <ul class="re_info">
        <li>
          <span>就诊人</span>
          <span>{{ info.patientName }}</span>
        </li>
        <li>
          <span>住院号</span>
          <span>{{ info.inpNo }}</span>
        </li>
        <li>
          <span>总费用</span>
          <span>{{ info.feeAmout == null?"0.00":info.feeAmout }}</span>
        </li>
        <li style="border: 0px;">
          <span>押金余额</span>
          <span>{{ info.inpPrepay == null?"0.00":info.inpPrepay }}</span>
        </li>
      </ul>
      <div class="re_zxcz">在线充值</div>
      <ul class="re_czje">
        <li v-for="(item, index) in moneyList" :key="index" @click="selMoney(item, index)" :class="current == index?`list_xuan`:` `">{{ item }}</li>
      </ul>
      <div class="re_amount" v-show="customShow">
        <div class="rea_title">请输入预交押金金额</div>
        <div class="rea_je">
          <van-field
            v-model="amount"
            maxlength="9"
            label="￥"
            @input="money"
          />
        </div>
      </div>
      <div class="yygh" >
        <van-button
          @click="payment2"
          type="info"
          :disabled="czMoney == 0 && amount == ''"
        >确&nbsp;&nbsp;认&nbsp;&nbsp;支&nbsp;&nbsp;付</van-button>
      </div>
    </div>
    <div class="empty_cl" v-if="!wjsShow">
      <img src="@/assets/bg/empty.png">
      <span>该就诊人当前暂无住院信息</span>
    </div>
    <van-popup v-model="showNation" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirmNation"
        @cancel="showNation = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { selectVisitinfos, getIpPatient, pay } from "@/request/api.js";
import { throttle, debounce } from "@/tool/shake.js";
export default {
  data(){
    return{
      showNation: false,
      columns: [],
      selectdata: {
        idcardno: ""
      },
      current: 10,
      card: {},
      info: {},
      amount: "",
      customShow: false,
      czMoney: 0,
      wjsShow: false,
      moneyList: ["50","100","200","500","1000","自定义"]
    }
  },
  created() {
    this.payment2 = debounce(this.payment,400);
    this.card = JSON.parse(sessionStorage.getItem("card"));
    this.getVisitinfos();
  },
  methods: {
    // 获取所有就诊人
    async getVisitinfos() {
      let openid = sessionStorage.getItem("openid");
      let res = await selectVisitinfos({ openid });
      this.columns = res.data.obj;
      res.data.obj.forEach(item => {
        item.text = item.patientname;
        if (item.style == 1) {
          this.selectdata = item;
        }
      });
      this.getInfo();
    },
    // 切换就诊卡
    onConfirmNation(value) {
      this.selectdata = value;
      this.showNation = false;
      this.getInfo();
      this.Toast("切换成功");
    },
    // 查看电子卡
    cardbtn(item){
      sessionStorage.setItem("card", JSON.stringify(item));
      this.$router.push("/HealthCard");
    },
    // 获取就诊人住院信息
    async getInfo() {
      let map = {
        patientId: this.selectdata.patientId,
        // patientId: "24813",
        userId: "7148"
      };
      let res = await getIpPatient(map);
      if(res.data.obj.resultData != null){
        res.data.obj.resultData.forEach(item => {
          if(item.outtime == null || item.outtime == "未出院"){
            this.info = item;
            this.wjsShow = true;
            return;
          } else {
            this.wjsShow = false;
          }
        });
      }
    },
    money(){
      this.current = 10;
      this.czMoney = 0;
      this.amount = this.amount.replace(/[^\d\.]/g,""); // 确保输入的是数字
      this.amount = this.amount.replace(/^\./g,""); // 确保第一位输入的是数字
      this.amount = this.amount.replace(/^0[0-9]/g,"0"); // 0开头的时候只能一位
      this.amount = this.amount.replace(/\.{2,}/g,""); // 确保不能输入两个小数点
      this.amount = this.amount.replace(".","$#$").replace(/\./g,"").replace("$#$","."); // 保证小数点只能出现一次，而不能出现两次以上
      this.amount = this.amount.replace(/^(\-)*(\d+)\.(\d\d).*$/,"$1$2.$3"); // 确保只能输入两位小数
    },
    formatter(value) {
      // 过滤输入的数字
      return value.replace(/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,'');
    },
    selMoney(data, index){
      if(data == "自定义"){
        this.current = 10;
        this.czMoney = 0;
        this.customShow = true;
        return;
      }
      this.customShow = false;
      this.czMoney = data;
      this.current = index;
      this.amount = "";
    },
    // 缴费
    async payment(){
      console.log(this.info)
      let map = {
        flag: 3, // 1=挂号缴费 2=门诊缴费 3=住院充值
        payTypeId: 1,
        orderDate: this.$moment().format("'YYYY-MM-DD'"),
        orderTime: this.$moment().format("HH:mm:ss"),
        orderTimeoutDate: "",
        // orderNo: this.info.inpNo,
        currencyCode: 156,
        orderAmount: this.czMoney == 0?this.amount:this.czMoney,
        // orderAmount: 0.01,
        payInDepositOrderPo: {
          inpNo: this.info.inpNo,
          inpNum: this.info.inpNum,
          // patientld: "24813", // 测试
          patientId: this.selectdata.patientId,
          type: 1
        }, // 入住院缴费实体
        payOpChargePo: {}, // 门诊缴费实体
        subsidAmount: "",
        expireDate: "",
        accountNo: "",
        openID: this.card.openid,
        orderDesc: "医院公众号住院预交金充值",
        receiverAddress: "",
        buyIp: ""
      }
      // console.log(JSON.parse(JSON.stringify(map)));
      let rs = await pay(map);
      let that = this;
      function onBridgeReady() {
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: rs.data.obj.sub_appId,
            timeStamp: rs.data.obj.timeStamp,
            nonceStr: rs.data.obj.nonceStr,
            signType: rs.data.obj.signType,
            paySign: rs.data.obj.paySign,
            package: rs.data.obj.package,
          },
          function (obj) {
            if (obj.err_msg == "get_brand_wcpay_request:ok") {
              if (res.data.message == "操作成功") {
                that.Toast.success("支付成功,即将返回预交金充值页面");
                setTimeout(() => {
                  // that.$router.push("/home");
                  that.$router.go(-1);
                }, 1500);
              } else if (obj.err_msg == "get_brand_wcpay_request:cancel") {
              } else {
              }
            }
          }
        );
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
    },
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  .current_user{
    position: relative;
    margin: 4px 4px 2px 4px;
    padding: 10px;
    background: #E6F5FC;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    >li{
      >span{
        letter-spacing: 0px;
      }
    }
    >li:nth-child(2){
      margin: 10px 0px;
    }
    .switch{
      position: absolute;
      top: 10px;
      right: 20px;
      color: #6098ff;
    }
    >img{
      position: absolute;
      width: 40px;
      right: 46px;
      bottom: 10px;
    }
  }
  .re_info, .re_amount{
    margin: 10px;
    background: white;
    border: 1px solid #eee;
    box-shadow: 0px 0px 8px #ddd;
    >li{
      font-size: 14px;
      padding: 10px 0px;
      margin: 0px 10px;
      border-bottom: 1px solid #eee;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
    }
  }
  .re_zxcz{
    padding: 0px 10px;
    font-size: 16px;
  }
  .re_czje{
    display: flex;
    padding: 0px 10px;
    flex-flow: row wrap;
    justify-content: space-between;
    >li{
      font-size: 16px;
      line-height: 40px;
      background: #ddd;
      border-radius: 2px;
      width: 30%;
      text-align: center;
      margin-top: 10px;
    }
    .list_xuan{
      // transition: all .6s;
      background: rgb(135, 211, 255);
    }
  }
  .re_amount{
    .rea_title{
      background: #F0F9FF;
      color: #1DA5F2;
      padding: 10px;
      text-align: center;
      letter-spacing: 1px;
    }
    /deep/ .rea_je{
      .van-cell{
        // margin: 0px 16px;
        // padding: 10px 0px;
        border-bottom: 1px solid #999;
        .van-field__label{
          font-size: 30px;
          // background: yellow;
          margin: 0px;
          width: 40px;
        }
        .van-field__control{
          font-size: 20px;
        }
      }
    }
  }
  /deep/ .yygh{
    width: 355px;
    margin: 20px 10px 0px;
    background: rgb(83, 192, 255);
    color: rgb(255, 255, 255);
    .van-button{
      text-align: center;
      background: rgb(83, 192, 255);
      padding: 24px 0px;
      width: 355px;
      font-size: 20px;
      border-color: rgb(62, 184, 255);
    }
  }
  .empty_cl{
    text-align: center;
    >img{
      width: 100%;
    }
    >span{
      font-size: 16px;
      letter-spacing: 1px;
      color: rgba(153, 153, 153, 0.8);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/Deposit/Recharge.vue